import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { UserRoute } from "./routes/userRoute";
import { TheatreRoute } from "./routes/theatreRoute";
import { AdminRoute } from "./routes/adminRoute";
import { DndProvider } from "react-dnd";
import {Toaster} from 'sonner'
import { HTML5Backend } from "react-dnd-html5-backend";
import NotFound404 from "./routes/protected/404Page";

function App() {
  return (
    <div className="App">
      {/* <ToastContainer /> */}
      <Toaster />
      <DndProvider backend={HTML5Backend}>
        {/* <ChakraProvider theme={customTheme}> */}
          <Routes>

            <Route path="/*" element={<UserRoute />} />
            <Route path="/theatre/*" element={<TheatreRoute />} />
            <Route path="/admin/*" element={<AdminRoute />} />

          </Routes>
          {/* </ChakraProvider> */}
      </DndProvider>
    </div>
  );
}

export default App;
